// const imageBaseUrl = "http://192.168.0.7:3001/uploads/"
// export default imageBaseUrl;

const imageBaseUrl = "https://apidev.pyne-mena.com/public/uploads/"
// const imageBaseUrl = "https://api.pyne-mena.com/public/uploads/"
export default imageBaseUrl
